/**
 * State used in rendering MenuItemLink
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
